<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>在线题库</el-breadcrumb-item>
        <el-breadcrumb-item>章节练习</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>一级建造师</span>
        </div>
        <el-button @click="add()" icon="el-icon-sort" type="primary">切换科目</el-button>
      </div>
      <div class="xcx-content flex" v-loading="loading">
        <div class="flex-grow bg-w mr20">

          <div class="pt20 pb20">

            <el-empty :image-size="200" v-if="tableData.length == 0"></el-empty>
            <div v-else>
              <div class="flex mb20">
                <div class="year-tag active">管理</div>
                <div class="year-tag">法规</div>
                <div class="year-tag">经济</div>
                <div class="year-tag">市政</div>
              </div>
              <div class="x">
                <div class="bg-F9F9F9 flex space alcenter box-border pl10 pr10 mb10" v-for="(v, i) in tableData"
                  :key="i">
                  <div class="flex-grow flex text-6F8199 ft16 text-over">

                    <el-tag v-if="v.type == 0" type="danger">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 1" type="success">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 2">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 3" type="warning">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 4" type="danger">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 5" type="warning">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 6" type="success">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 7">{{ v.type_name }}</el-tag>

                    <div class="truncate" :title="v.title">{{ v.title }}</div>
                  </div>
                  <div class="flex-shrink-0 ml30">
                    <div class="text-6F8199 ft14">
                      <el-tag type="success">￥：{{ v.amount }}</el-tag>
                    </div>
                  </div>
                  <div class="flex-shrink-0 text-6F8199 ft14 ml30">下单时间：{{ v.created_at }}
                  </div>
                  <div class="flex-shrink-0 ml30">
                    <el-button v-if="v.type == 5 || v.type == 6 || v.type_id == 3" type="primary"
                      @click="downLoadFile(v)" icon="el-icon-download">下载资料</el-button>
                    <el-button icon="el-icon-view" v-else-if="v.type == 7 && v.type_id == 4" type="warning"
                      @click="goCourseVideo(v)">查看物流
                    </el-button>
                    <el-button icon="el-icon-finished" v-else type="success">订单完成</el-button>
                  </div>
                </div>
              </div>
              <!--分页-->
              <div class="paging">
                <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
                  layout="total, prev, pager, next" :total="count" :page-size="limit"></el-pagination>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <el-dialog title="订单物流信息" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
      <el-form :inline="true">
        <el-form-item label="物流名称：" label-width="100px">
          {{ express_id }}
        </el-form-item>
        <el-form-item label="物流单号：" label-width="100px">
          {{ express_no }}
        </el-form-item>
      </el-form>
      <el-empty :image-size="100" v-if="gridData.length == 0"></el-empty>
      <el-table :data="gridData">
        <el-table-column property="title" label="资料名称"></el-table-column>
        <el-table-column property="size" label="大小" width="100"></el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button @click="downLoadFiles(scope.row, 1)" type="danger" round icon="el-icon-download">下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTableVisible: false,
      loading: true,
      tableData: [],
      gridData: [],
      page: 0,
      count: 0,
      limit: 8,
      express_id: "",
      express_no: "",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    goCourseVideo(v) {
      let that = this;
      that.express_id = v.express_id;
      that.express_no = v.express_no;
      that.getOrderDownload(v.id);
      that.dialogTableVisible = true;
    },

    getOrderDownload(ids) {
      let that = this;
      that.axios.post("/getOrderDownload", { id: ids }).then((res) => {
        if (res.code == 200) {
          that.gridData = res.data;
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    downLoadFile(v) {
      let that = this;
      that.axios.post("/getOtherDownloadUrl", { id: v.id }).then((res) => {
        if (res.code == 200) {
          window.open(res.data.urls);
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    downLoadFiles(v) {
      let that = this;
      that.axios.post("/getDownloadUrl", { id: v.id }).then((res) => {
        if (res.code == 200) {
          window.open(res.data.urls);
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      formData.type = 1;
      that.axios.post("/getOrders", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.xcx-head {
  margin-bottom: 0px;
}

.flex-grow {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.inline-block {
  display: inline-block;
}

.thumb_images {
  width: 100%;
  height: 175px;
  border-radius: 5px;
}

.border-tags {
  border: 1px solid #c18958;
}

.text-tags {
  color: #c18958;
}

.text-6581A0 {
  color: #6581a0;
}

.bg-F9F9F9 {
  background: #f9f9f9;
  height: 60px;
}

.text-6F8199 {
  color: #6f8199;
  align-items: center;
}

.border-sub {
  border: 1px solid #cccccc;
}

.year-tag {
  background-color: #f0f3f7;
  color: #233650;
  width: 106px;
  height: 42px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}

.year-tag.active {
  background-color: #3078ff;
  color: #fff;
  position: relative;
}

.year-tag.active::after {
  content: "";
  display: block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #3078ff;
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -7px;
}

.truncate {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>